import { screen, colors, fonts } from 'components/styles/variables';

interface Props {
  dealerName: string;
  className?: string;
}

export default function Header({ dealerName, className }: Props): JSX.Element {
  return (
    <header className={className}>
      <h1>{dealerName}</h1>
      <style jsx>{`
        header {
          display: flex;
          flex-direction: column;
        }

        h1 {
          font-family: ${fonts.default};
          font-style: normal;
          font-weight: bold;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: 0.2px;
          text-transform: uppercase;
          color: ${colors.BLACK};
          margin: 0;
        }

        @media screen and (min-width: ${screen.smMin}) {
          h1 {
            font-size: 20px;
          }
        }
      `}</style>
    </header>
  );
}
